<div class="field" #fieldGroups>
    <span class="field-title">Lugar de procedencia<span class="asterisk">*</span></span>

    <app-province style="margin-top: -8px;" [fieldIdentificator]="fieldIdentificator" (focusEvent)="emitField(fieldGroups)"></app-province>
    <app-town style="margin-top: -8px;" [fieldIdentificator]="fieldIdentificator" (focusEvent)="emitField(fieldGroups)"></app-town>

</div>